(function () {
  'use strict';

  angular.module('app').component('debitNotesPage', debitNoteListCtrl());

  function debitNoteListCtrl() {
    return {
      bindings: {},
      controller: DebitNoteListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/debit-notes/debit-notes-page.component.html',
    };
  }

  DebitNoteListCtrl.$inject = ['$location', 'UtilService', 'AbilityService', 'DebitNoteService'];

  function DebitNoteListCtrl($location, UtilService, AbilityService, DebitNoteService) {
    const vm = this;

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = DebitNoteService.getFilterCriteria();

    vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(vm.UtilService.startOfMonth());
    vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.UtilService.today());

    vm.permissions = {
      canCreate: AbilityService.can('create_debitnote_accountadmin'),
    };

    // Methods
    vm.createDebitNote = createDebitNote;
    vm.onShowItem = onShowItem;

    // Initializers
    getItems();

    function getItems() {
      vm.loadingItems = true;
      DebitNoteService.getDebitNotes(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function createDebitNote() {
      $location.path('/debit_notes/new');
    }

    function onShowItem(item, mode) {
      $location.path(`/debit_notes/${item.id}`).search({ mode: mode });
    }
  }
})();
